import { useEffect, useState } from 'react';

import { useAccount } from 'wagmi';

import { isLedgerConnectorId, isLedgerLiveBrowser } from '@/config/ledgerLive';

export const useLedgerLive = () => {
  const { connector } = useAccount();

  const [isLedgerInjected, setIsLedgerInjected] = useState(false);

  useEffect(() => {
    // Detected from the provider's `isLedgerLive` flag rather than the user agent:
    // the old `/Ledger/i` test also matched unrelated clients, and Ledger Wallet's UA
    // is not part of their integration contract.
    setIsLedgerInjected(isLedgerLiveBrowser());
  }, []);

  // Ledger reaches the app either as the EIP-6963 connector or as the injected
  // fallback, so both ids mean the session is running through Ledger.
  const isLedgerConnected = isLedgerConnectorId(connector?.id);

  const isLedgerLiveENV = isLedgerInjected && isLedgerConnected;

  return { isLedgerConnected, isLedgerInjected, isLedgerLiveENV };
};

export default useLedgerLive;
